/**
 * Whether the client is outside the age range we can quote insurance for. Paywalls warn such clients
 * that only a self-funding plan is available to them.
 */
import { useSelector } from 'react-redux';
import { isAgeInRange } from '@shared';
import { calcClientDemographics } from '@shared/calculations/demographics';
import { selectIntakeSurvey } from '@/model';

export function useIsAgeIneligibleForQuotes(): boolean {
  const intakeSurvey = useSelector(selectIntakeSurvey);
  const { primaryAge } = calcClientDemographics(intakeSurvey ?? {});
  return primaryAge > 0 && !isAgeInRange(primaryAge);
}
